import { format, isToday, isYesterday } from 'date-fns';

export function formatParticipantLastSeenAt(lastSeenAt: string | null | undefined): string {
  if (!lastSeenAt) {
    return 'Offline';
  }

  try {
    const date = new Date(lastSeenAt);
    if (Number.isNaN(date.getTime())) {
      return 'Offline';
    }

    const time = format(date, 'HH:mm');

    if (isToday(date)) {
      return `Last seen today at ${time}`;
    }

    if (isYesterday(date)) {
      return `Last seen yesterday at ${time}`;
    }

    return `Last seen ${format(date, 'd MMM, HH:mm')}`;
  } catch {
    return 'Offline';
  }
}

export function buildUserPresenceLabel(user: {
  isOnline?: boolean;
  lastSeenAt?: Date | null;
}): { online: boolean; lastSeenLabel: string } | null {
  if (user.isOnline === undefined) {
    return null;
  }

  return buildParticipantPresenceLabel({
    isOnline: user.isOnline === true,
    lastSeenAt: user.lastSeenAt?.toISOString() ?? null,
  });
}

export function buildParticipantPresenceLabel(input: {
  isOnline: boolean;
  lastSeenAt: string | null | undefined;
}): { online: boolean; lastSeenLabel: string } {
  if (input.isOnline) {
    return { online: true, lastSeenLabel: 'Online' };
  }

  return {
    online: false,
    lastSeenLabel: formatParticipantLastSeenAt(input.lastSeenAt),
  };
}
